import { useState, useLayoutEffect } from 'react';

export const useGlobalState = () => {

    const [login, setLogin] = useState('');
    const [trackingModal, setTrackingModal] = useState(false);

    const data = [];

    return { login, setLogin, trackingModal, setTrackingModal, data }
}

export const useMasterData = () => {

    const [LIST_CLIENT, setLIST_CLIENT] = useState([]);
    const [LIST_CLIENTVAS, setLIST_CLIENTVAS] = useState([]);
    const [LIST_SERVICE, setLIST_SERVICE] = useState([]);
    const [LIST_NETWORK, setLIST_NETWORK] = useState([]);
    const [LIST_CITY, setLIST_CITY] = useState([]);
    const [LIST_COUNTRY, setLIST_COUNTRY] = useState([]);
    const [LIST_PINCODE, setLIST_PINCODE] = useState([]);
    const [LIST_STATE, setLIST_STATE] = useState([]);
    const [list_loadRateForAutoCalculation,setList_loadRateForAutoCalculation] = useState([])
    const [list_loadRateForLogistic,setList_loadRateForLogistic] = useState([])
    const [ORIGINAL_ZONECODE,setORIGINAL_ZONECODE] = useState("");
    const [ZONECODE_MAPPED_WITHCITY,setZONECODE_MAPPED_WITHCITY] = useState("");
    const [WEIGHT_TYPE,setWEIGHT_TYPE] = useState("");
    const [WEIGHT_SLAB,setWEIGHT_SLAB] = useState(0);
    const [LIST_TATDAYS,setLIST_TATDAYS] = useState([]);
    const [LIST_CLIENTSERIESATE,setLIST_CLIENTSERIESATE] = useState([]);
    const [isClientLoaded,setIsClientLoaded] = useState(false);
    return {LIST_CLIENT, setLIST_CLIENT,
        LIST_CLIENTVAS, setLIST_CLIENTVAS, 
        LIST_SERVICE, setLIST_SERVICE, 
        LIST_NETWORK, setLIST_NETWORK, 
        LIST_CITY, setLIST_CITY, 
        LIST_COUNTRY, setLIST_COUNTRY,
        LIST_PINCODE, setLIST_PINCODE,
        LIST_STATE, setLIST_STATE,
        list_loadRateForAutoCalculation,
        setList_loadRateForAutoCalculation,list_loadRateForLogistic,
        setList_loadRateForLogistic,
        ORIGINAL_ZONECODE,setORIGINAL_ZONECODE,
        ZONECODE_MAPPED_WITHCITY,setZONECODE_MAPPED_WITHCITY,
        WEIGHT_TYPE,setWEIGHT_TYPE,
        WEIGHT_SLAB,setWEIGHT_SLAB,
        LIST_TATDAYS,setLIST_TATDAYS,
        LIST_CLIENTSERIESATE,setLIST_CLIENTSERIESATE,
    isClientLoaded,setIsClientLoaded}
}

export function useWindowSize() {
    const [size, setSize] = useState([0, 0]);

    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    
    return size;
}